import { render, staticRenderFns } from "./SubscriptionWall.vue?vue&type=template&id=0c2317d0&scoped=true&"
import script from "./SubscriptionWall.vue?vue&type=script&lang=js&"
export * from "./SubscriptionWall.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionWall.vue?vue&type=style&index=0&id=0c2317d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2317d0",
  null
  
)

export default component.exports